// signingDuration 기본값은 14일 = 14 * 24 * 60 분 = 20160 분 입니다.
export const DEFAULT_SIGNING_DURATION = 14 * 24 * 60;
